export default __webpack_public_path__ + "static/goldfilingdust-5a258cd7e365481e7fd6d6ccd571237e.png";